import * as Sentry from "@sentry/react"

declare const __SENTRY_DSN__: string
const dsn = typeof __SENTRY_DSN__ !== "undefined" ? __SENTRY_DSN__ : ""

if (dsn) {
  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
